import React from 'react';
import { Home, Zap, ShieldCheck, Lock, ArrowRight } from 'lucide-react';
import { Button, Badge } from './ui';
import { MOCKUP_URL } from '../data/kit';
export function Hero() {
  return <section className="bg-cream-50 sm:min-h-screen sm:min-h-[100svh] flex flex-col justify-start sm:justify-center pt-3 pb-8 sm:pt-12 sm:pb-16 md:pt-16 md:pb-20 px-5" data-id="element-141" data-mp="9kjvgl9o4y23">
      <div className="w-full max-w-5xl mx-auto text-center" data-id="element-142" data-mp="4jm7fs1z99so">
        <div className="inline-flex items-center gap-1.5 sm:gap-2" data-id="element-143" data-mp="128607wumu8qj">
          <span className="text-sm sm:text-xl" aria-hidden="true" data-id="element-144" data-mp="x9uqdm4c7y8b">⭐</span>
          <span className="text-rose-600 font-bold tracking-widest uppercase text-[11px] sm:text-sm" data-id="element-145" data-mp="x8joxsyd72kd">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="font-serif font-bold text-wine tracking-tight max-w-4xl mx-auto mt-3 sm:mt-10" data-id="element-146" data-mp="nbey3ftkqix8">
          <span className="block leading-[1.08] text-[26px] sm:text-[50px] md:text-[62px] [text-wrap:balance]" data-id="element-147" data-mp="3d33h34xud5nx">
            RECUPERÁ EL CONTROL DE TU SUELO PÉLVICO.
          </span>
          <span className="block leading-none text-rose-600 text-[30px] sm:text-[56px] md:text-[70px] mt-1.5 sm:mt-5" data-id="element-148" data-mp="3j9kc5f0exnhp">
            EN 21 DÍAS.
          </span>
        </h1>

        <div className="mt-3 mb-2.5 sm:mt-12 sm:mb-10 flex justify-center" data-id="element-149" data-mp="39al7s8moke0i">
          <img src={MOCKUP_URL} alt="Suelo Pélvico Fuerte +40 — Guía principal + 4 bonos · Material digital" className="w-full max-w-[310px] sm:max-w-[560px] h-auto mx-auto" width={1300} height={1200} loading="eager" fetchPriority="high" decoding="async" data-id="element-150" data-mp="39cpa4m4xl4yo" />
        </div>

        <p className="font-serif text-wine font-bold tracking-tight leading-tight text-[17px] sm:text-2xl md:text-[28px] max-w-2xl mx-auto [text-wrap:balance]" data-id="element-151" data-mp="2qloea6z3xpjc">
          EL MÉTODO VISUAL PARA TRABAJAR TU SUELO PÉLVICO DESDE CASA
        </p>

        <p className="mt-1.5 sm:mt-3 text-ink-muted text-[13px] sm:text-base leading-snug sm:leading-relaxed max-w-xs sm:max-w-md mx-auto [text-wrap:balance]" data-id="element-152" data-mp="2lkij82hz5q6n">
          Para mujeres +40 que sienten que su suelo pélvico ya no responde como antes.
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 sm:gap-2 mt-3 mb-3 sm:mt-8 sm:mb-8" data-id="element-153" data-mp="n98crlqgh1mu">
          <Badge className="whitespace-nowrap px-2 py-0.5 text-[11px] sm:px-3 sm:py-1 sm:text-xs" data-id="element-154" data-mp="ia5i8v83qdt4">
            <span className="mr-1 sm:mr-1.5" aria-hidden="true" data-id="element-155" data-mp="db2ct9o7m5km">💜</span> Guía + 4 Bonos
          </Badge>
          <Badge className="whitespace-nowrap px-2 py-0.5 text-[11px] sm:px-3 sm:py-1 sm:text-xs" data-id="element-156" data-mp="1ayt68yk8jhad">
            <Home className="w-3.5 h-3.5 mr-1 sm:mr-1.5 text-rose-500" data-id="element-157" data-mp="15zq69sj44199" /> Desde casa
          </Badge>
          <Badge className="whitespace-nowrap px-2 py-0.5 text-[11px] sm:px-3 sm:py-1 sm:text-xs" data-id="element-158" data-mp="114kj6qdz4gjl">
            <Zap className="w-3.5 h-3.5 mr-1 sm:mr-1.5 text-rose-500" data-id="element-159" data-mp="x3h2k1o3qghb" /> Acceso inmediato
          </Badge>
        </div>

        <div className="flex flex-col items-center gap-3 sm:gap-5" data-id="element-160" data-mp="3hrlmgnykwhbm">
          <Button size="md" className="w-full max-w-md group leading-snug text-center px-6 py-3.5 sm:py-4 text-[16px] whitespace-nowrap" onClick={() => document.getElementById('planes')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-161" data-mp="3htg864hocdgr">
            QUIERO EMPEZAR MIS 21 DÍAS
            <ArrowRight className="hidden sm:block ml-2 w-5 h-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-162" data-mp="2b2ai0v51khgf" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-x-4 sm:gap-x-6 gap-y-1 sm:gap-y-2 text-xs sm:text-sm text-ink-muted" data-id="element-163" data-mp="2kydt4qhvfqfi">
            <span className="flex items-center" data-id="element-164" data-mp="2p1a6o2sk0wcl">
              <ShieldCheck className="w-4 h-4 mr-1 text-sage-600" data-id="element-165" data-mp="2u03lbyjkutec" /> Garantía 7 días
            </span>
            <span className="flex items-center" data-id="element-166" data-mp="umzfvosefs46">
              <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-167" data-mp="uoaivme0svu8" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-168" data-mp="zm2lbacak0co">
              <Zap className="w-4 h-4 mr-1 text-rose-500" data-id="element-169" data-mp="4b49k00jcgmm" /> Acceso inmediato
            </span>
          </div>
        </div>
      </div>
    </section>;
}